export enum LogisticStatusEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Closed = 'Closed',
}
